import React from 'react';
import { Badge } from 'reactstrap';

let EmptyBadge = (props) => {
    let size = props.size || 2;
    return (
        <Badge
            color={props.color}
            dangerouslySetInnerHTML={{ __html: "··" }}
            style={{ color: "transparent", marginLeft: 5, marginRight: 5, width: size, height: size, ...props.style }} />
    );
}

export default EmptyBadge;